import MActionCard from './index.vue';

MActionCard.install = app => {
  app.component(MActionCard.name, MActionCard);
};

export default MActionCard;
